module.exports = __webpack_public_path__ + "static/5-e40eefe4bc6e6e65389f338481606e40.pdf";